import { NgModule } from '@angular/core';

import { RevendaComponent } from './revenda.component';

import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    RevendaComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    RevendaComponent
  ]
})

export class RevendaModule { }
